import script from "./setAvailability.vue?vue&type=script&setup=true&lang=js"
export * from "./setAvailability.vue?vue&type=script&setup=true&lang=js"

import "./setAvailability.vue?vue&type=style&index=0&id=b4b00952&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b00952"]])

export default __exports__